import { Trail } from './trail.interface';

export const PavementRoads: Trail[] = [
  {
    code: 'carretera',
    name: 'Carretera',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 0,
      banned: false,
      description: ''
    }
  },
  {
    code: 'calle-hotel',
    name: 'Calle del Hotel',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 0,
      banned: false,
      description: ''
    }
  },
  {
    code: 'olinala',
    name: 'Antigua Carretera a Olinalá',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 0,
      banned: false,
      description: ''
    }
  }
];



// WEBPACK FOOTER //
// /Users/mundofr/GitHub/Angle/ChipinqueTrails/src/app/pavementroads.data.ts